/* tslint:disable */
/* eslint-disable */
/**
 * Haltian API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * General info response object
 * @export
 * @interface GetDeploymentGroupResponse
 */
export interface GetDeploymentGroupResponse {
    /**
     * 
     * @type {object}
     * @memberof GetDeploymentGroupResponse
     */
    data?: object;
}

export function GetDeploymentGroupResponseFromJSON(json: any): GetDeploymentGroupResponse {
    return GetDeploymentGroupResponseFromJSONTyped(json, false);
}

export function GetDeploymentGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeploymentGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function GetDeploymentGroupResponseToJSON(value?: GetDeploymentGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}


